// extracted by mini-css-extract-plugin
export var borderRadius = "_fk-4";
export var large = "_fk-3";
export var logoContainer = "_fk-0";
export var nameLogo = "_fk-2";
export var small = "_fk-1";